export const getShouldDisableCostReview = ({ isRating, hasRateErrors, hasRate, hasProvidedRate }) => {
  return isRating || hasRateErrors || !hasRate || hasProvidedRate;
};
